<template>

    <!-- szkielet bootstrapowego modala (JS bootstrap.Modal, data-bs-target="#loginDialog"
         w naglowku strony), srodek w stylistyce cf-modal (redesign z CardFinance2) -->
    <div class="modal fade" ref="modal" id="loginDialog" tabindex="-1" aria-labelledby="login-title">

      <div class="modal-dialog modal-dialog-centered cf-modal-dialog">
        <div class="modal-content cf cf-modal">

          <div class="cf-modal__head">
            <div class="cf-stack" style="gap:6px">
              <h2 class="cf-h2" id="login-title" style="font-size:23px">Zaloguj się</h2>
              <p class="cf-meta" style="margin:0">Strefa klienta NAU</p>
            </div>
            <button type="button" class="cf-modal__close" data-bs-dismiss="modal" aria-label="Zamknij">×</button>
          </div>

          <form class="cf-modal__body" novalidate @submit.prevent="doLogin">

            <div class="cf-field">
              <label class="cf-field__label" for="l-email">E-mail</label>
              <input ref="input" id="l-email" class="cf-input" type="email" autocomplete="username"
                     v-model="creds['user']" @focus="err=''"
                     :data-error="invalidUser || invalidCreds ? 'true' : null">
              <span v-if="invalidUser" class="cf-field__error">Podaj adres e-mail.</span>
            </div>

            <div class="cf-field">
              <div class="cf-row cf-row--split">
                <label class="cf-field__label" for="l-pass">Hasło</label>
                <a href="#" class="cf-nowrap" style="font-size:12.5px" id="zapomnialeshasla"
                   data-bs-toggle="modal" data-bs-target="#ForgotPasswordModal" @click="forgot">Nie pamiętasz hasła?</a>
              </div>
              <input id="l-pass" class="cf-input" type="password" autocomplete="current-password"
                     v-model="creds['passwd']" @focus="err=''"
                     :data-error="invalidPassword || invalidCreds ? 'true' : null">
              <span v-if="invalidPassword" class="cf-field__error">Podaj hasło.</span>
              <span v-else-if="invalidCreds" class="cf-field__error">Nieprawidłowy e-mail lub hasło.</span>
            </div>

            <button type="submit" class="cf-btn cf-btn--primary cf-btn--block dologin"
                    :aria-disabled="busy ? 'true' : 'false'">{{ busy ? 'Logujemy…' : 'Zaloguj się' }}</button>

            <p class="cf-meta" style="margin:0;text-align:center">Nie masz konta?
              <a href="#" @click.prevent="goApply">Złóż wniosek o pożyczkę</a> — konto założysz przy okazji.</p>

          </form>

        </div>
      </div>

    </div>

</template>

<script>

import ZetosForgotPassword from './ForgotPasssword';

  export default {

     components: {
       ZetosForgotPassword
    },
    data() {
      return {


        creds: {},


        isDirty: false,

        // trwa logowanie (CTA zablokowane)
        busy: false,


        err: '',

        modal:null

      }
    },
    methods: {

      // "Nie pamietasz hasla?" - link ma data-bs-target na modal przypomnienia;
      // chowamy logowanie, zeby nie nakladac dwoch backdropow
      forgot() {

        this.modal && this.modal.hide();
      },


      // "Zloz wniosek" - zamykamy modal i na formularz
      goApply() {

        this.modal && this.modal.hide();

        this.$route.path !== '/' && this.$router.push({path: '/'});
      },


      doLogin() {


        this.isDirty = true;


        if (this.invalidUser || this.invalidPassword || this.busy) {
          return;
        }

        this.busy = true;



          this.post( '/client/login', {

            client_login: this.creds.user.trim(),
            client_password: this.creds.passwd.trim()

          })
          .then(response => {

            this.busy = false;

            if (!!response.data) {

              let ok = !(response.data.IS_ERROR | 0);



              // due to incompatible income types dictionary and backend name mapping issue we have to remap income type to valid front ids
              let employment = new Map([
                ['-6', '0'],
                ['5', '0'],
                ['20', '0'],
                ['8', '2'],
                ['15', '2'],
                ['-2', '9'],
                ['2', '9'],
                ['4', '9'],
                ['17', '9'],
                ['6', '11'],
                ['18', '11'],
                ['-5', '8'],
                ['7', '8'],
                ['-1', '5'],
                ['9', '5'],
                ['11', '5'],
                ['3', '6']
              ]);


              response.data.hasOwnProperty('income_type_id')
                && (response.data.income_type_id = employment.has(response.data.income_type_id) ? employment.get(response.data.income_type_id) : '4');


              this.echo('logged_in', response.data);


              localStorage.setItem('user', JSON.stringify(response.data));

              this.modal.hide();

              this.$router.push({path: 'client'});


            }


          })
          .catch(error => {

            this.busy = false;


              // Error
              if (error.response) {

                  if (!!error.response.data.IS_ERROR) {

                    this.err = true;
                  }

              }

          });

      }


    },


    computed: {


      invalidUser() {
        return this.isDirty && !this.creds['user']
      },

      invalidPassword() {
        return this.isDirty && !this.creds['passwd']
      },

      invalidCreds() {
        return this.isDirty && this.err
      }
    },



    created() {


      this.listen('login_dialog', () => {
        this.modal.show();
      });


    },


    mounted(){


      this.modal = new bootstrap.Modal(this.$refs['modal']);
    }

  }



</script>
<style scoped>
/* wyglad modala: cf-modal w src/assets/cf-theme.css */
</style>



// WEBPACK FOOTER //
// src/components/LoginPopup.vue